export default __webpack_public_path__ + "static/media/image_11.1d431b73.jpg";